(function() {
    let tlFreeGiftOfferClone;
    let embedWidgetClone ;
    
    Object.defineProperty(window, "tlFreeGiftOffer", {
        get() {
            return tlFreeGiftOfferClone;
        },
        set(val) {
            if (val && !tlFreeGiftOfferClone) {
                tlFreeGiftOfferClone = val;
                if (window.location.pathname.includes("/cart")) {
                    val.cartHasChanged = true;
                }
            }
        },
        configurable: true
    });
})();